import { useAutoScroll } from '@/hooks/useAutoScroll';
import { useState } from 'react';

export const ScrollableChildText = ({
  text,
  className = '',
}: {
  text: string;
  className?: string;
}) => {
  const { elementRef, startAutoScroll, stopAndReset } = useAutoScroll();
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
    startAutoScroll();
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    stopAndReset();
  };

  return (
    <span
      ref={elementRef}
      className={`font-medium sidebar-child-text ${className}`}
      style={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: isHovered ? 'clip' : 'ellipsis',
        display: 'block',
        cursor: 'pointer',
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {text}
    </span>
  );
};
